export default {"src":"/_next/static/media/logo.30b68bc2.svg","height":42,"width":163,"blurWidth":0,"blurHeight":0};